import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPatientMessages(patientId) {
    return useQuery(
        ['patient', patientId, 'messages'],
        () => {
            return PESService.getPatientMessages(patientId);
        },
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchPatientMessages;
